<div class="command-dialog">
  <div [ngStyle]="{ transform: styleTransform }" class="cmdk-command">
    <div class="flex justify-between">
      <div>
        @for (page of pages; track page) {
          <div class="cmdk-vercel-badge theme-bg-2 blue-theme-text-1">
            {{ page.label }}
          </div>
        }
      </div>
    </div>

    <input
      [formControl]="commandSearchControl"
      [placeholder]="activePage.placeholder"
      class="cmdk-input theme-bg-2"
    />

    @if (filteredItems.length) {
      <div class="cmdk-list">
        @for (item of filteredItems; track item.id; let index = $index) {
          <div class="cmdk-group">
            <div
              class="cmdk-item"
              [ngClass]="{ 'theme-bg-2': selectedItemIndex === index }"
            >
              <button
                (click)="selectItem(index)"
                class="cmdk-item"
                [value]="item?.label"
              >
                @if (item.icon) {
                  <mat-icon class="material-icons-outlined">{{
                    item.icon
                  }}</mat-icon>
                }
                {{ item.label }}
              </button>
              @if (item.shortcutLabel) {
                <div class="cmdk-vercel-shortcuts">
                  @for (key of item.shortcutLabel.split(' '); track key) {
                    <div class="kbd theme-bg-2 theme-text-2">
                      <kbd>{{ key }}</kbd>
                    </div>
                  }
                </div>
              }
            </div>
          </div>
        }
      </div>
    } @else if (
      filteredItems.length === 0 &&
      commandSearchControl.value &&
      commandSearchControl.value.length > 0 &&
      activePage.id !== 'direct-collect' &&
      !isLoading
    ) {
      <phoenix-no-data></phoenix-no-data>
    }

    <phoenix-timeline-detail-container
      [timelineSelectedItem]="timelineSelectedItem"
      [removeMovement]="true"
    ></phoenix-timeline-detail-container>
  </div>
</div>
